import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  projectContainer: {
    width: 752,
    "@media (max-width: 1100px)": {
      width: "80%",
      // width: 600,
    },
    "@media (max-width: 650px)": {
      width: "auto",
    },
    background: "#E6EDF3",
    borderRadius: 12,
    padding: "35px 40px",
    marginTop: 25,
    marginBottom: 30,
  },
  Input: {
    backgroundColor: "#F4F6F8",
    width: "100%",
    outline: "none",
    height: 46,
    borderWidth: 1,
    padding: "15px 15px",
    boxSizing: "border-box",
    border: "1px solid #D4DDE4",
    borderRadius: 8,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: 16,
    color: "#5B6773",
    marginTop: 10,
  },
  projectSelect: {
    paddingLeft: 15,
    // marginRight: 15,
    border: "1px solid #D4DDE4",
    backgroundColor: "#F4F6F8",
    borderRadius: 6,
    fontWeight: "400",
    fontSize: 16,
    color: "#5B6773",
    fontFamily: "Roboto",
    width: "100%",
    height: 45,
    margin: 0,
    padding: 0,
    borderRadius: 8,
  },
  selectSelected: {
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  project_PTag: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: 16,
    margin: 0,
  },
  projectBtnContainer: {
    textAlign: "center",
  },
  projectBtn: {
    height: 42,
    fontWeight: "600",
    fontSize: 14,
    color: "#824ED2",
    fontFamily: "Roboto",
    textTransform: "none",
    border: "transparent",
    background: "rgba(130, 78, 210, 0.16)",
    borderRadius: 4,
    width: 200,
  },
  marginDiv: {
    marginTop: 29,
  },
  eventContainer: {
    borderRadius: 12,
    marginTop: 25,
  },
  table: {
    minWidth: 650,
    // width: '100%',
    [theme.breakpoints.down("sm")]: {
      width: 1500,
    },
  },
  eventText: {
    margin: 0,
    fontWeight: "500",
    fontSize: 26,
    color: "#091E42",
    fontFamily: "Roboto",
  },
  select: {
    border: "1px solid #D4DDE4",
    backgroundColor: "#F4F6F8",
    borderRadius: 6,
    fontWeight: "400",
    fontSize: 16,
    color: "#5B6773",
    fontFamily: "Roboto",
    "@media (min-width: 1600px)": {
      width: 101,
    },
    paddingLeft: 14,
    paddingRight: 14,
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  customBtn: {
    margin: 0,
    padding: 0,
    fontWeight: "600",
    fontSize: 14,
    color: "#824ED2",
    fontFamily: "Roboto",
    textTransform: "none",
    border: "none",
  },
  teamContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 30,
    "@media (max-width: 460px)": {
      display: "block",
    },
  },
  teamBtnContainer: {
    width: 360,
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 460px)": {
      width: "auto",
    },
  },
  teamBtn: {
    background: "linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)",
    fontSize: 14,
    padding: 0,
    color: "#ffffff",
    fontFamily: "Roboto",
    borderRadius: 6,
    textTransform: "none",
    width: "156px",
    height: 34,
    "@media (max-width: 370px)": {
      width: "140px",
      fontSize: "12px",
    },
  },
  teamTableBtn: {
    margin: 0,
    fontWeight: "600",
    fontSize: 14,
    color: "#824ED2",
    fontFamily: "Roboto",
    textTransform: "none",
    border: "transparent",
    background: "rgba(130, 78, 210, 0.16)",
    borderRadius: 4,
    marginLeft: 10,
  },
}));
